import { render, staticRenderFns } from "./Chamadas.vue?vue&type=template&id=69bd9172"
import script from "./Chamadas.vue?vue&type=script&lang=js"
export * from "./Chamadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports